// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.date-filter-form-campaign {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 25px 20px;
  margin: 20px auto; 
  gap: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px; 
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
    
  .campaign-date-field {
    display: flex;
    flex-direction: column;
    width: 25%
  }
    
  .campaign-date-field label {
    font-weight: bold;
    margin-bottom: 8px;
    text-align: left;
  }
    
  .campaign-date-field input {
    padding: 10px 5px;
    font-size: 16px;
    border: 1px solid #f2f2f2;
  }
    
    .campaign-form-actions {
      display: flex;
      gap: 10px;
      align-items: center;
      padding: 15px 0 0;
    }
    
    .campaign-form-actions .btn {
      padding: 8px 16px;
      font-size: 16px;
      color: #fff;
      border-radius: 4px;
      cursor: pointer;
    }
    
    .campaign-form-actions .submit-btn {
      background-color: #44a67e;
      border-color: #44a67e;
    }
    
    .campaign-form-actions .submit-btn:hover {
      background-color: #44a67e;
      border-color: #44a67e;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
    }
    
    .campaign-form-actions .download-btn {
      background: #373435;
      color: #ffcc29;
    }
    
    .campaign-form-actions .download-btn:hover {
      background: #373435;
      color: #ffcc29;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
    }

  /* Responsive Styles */
@media (max-width: 700px) {
  .date-filter-form-campaign {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .campaign-date-field input {
    max-width: 100%;
  }

  .campaign-form-actions {
    flex-direction: column;
    width: 100%;
  }

  .campaign-form-actions .btn {
    width: 100%;
    text-align: center;
  }
}  
  
    /* Summary Report Table Style */
    .campaign-report-table-container {
      width: 100%;
      overflow-x: auto;
      margin-top: 20px;
      border-radius: 8px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      background: #fff;
    }
    
    .campaign-report-table {
      width: 100%;
      border-collapse: collapse;
      text-align: left;
    }
    
    .campaign-report-table th,
    .campaign-report-table td {
      padding: 12px 15px;
      border: 1px solid #ddd;
      font-size: 14px;
    }
    
    .campaign-report-table th {
      background-color: #f4f4f4;
      color: #373435;
      font-weight: 600;
      text-transform: uppercase;
      text-align: left;
    }
    
    .campaign-report-table tbody tr:nth-child(even) {
      background-color: #f9f9f9;
    }
    
    .campaign-report-table tbody tr:hover {
      background-color:  rgba(255, 204, 41, 0.2);
    }
    
    .campaign-report-table td {
      color: #373435;
    }
    
    .campaign-report-table tbody tr:last-child td {
      border-bottom: 2px solid #ffcc29;
    }
  
    /* Expand Button */
    .campaign-expand-btn {
      background: #373435;
      color: #ffcc29;
      border: none;
      padding: 5px 10px;
      cursor: pointer;
      border-radius: 4px;
      font-size: 16px;
    }
    
    .campaign-expand-btn:hover {
      background: #ffcc29;
      color: #373435;
    }
    
    /* Expanded Row */
    .campaign-expanded-row {
      background-color: #eef7ff;
    }
    
    .campaign-expanded-content {
      padding: 10px;
    }

    @media screen and (max-width: 1100px) {
      .campaign-under-1000px {
        display: none;
      }
    }
    
    @media screen and (min-width: 1101px) {
      .campaign-toggle-button-expansion {
        display: none;
      }
    }

    .analytics-btn {
      background: #373435;
      border: 1px solid #373435;
      color: #ffcc29;
      padding: 5px;
      margin: 0 10px;
      cursor: pointer
    }

    .clicker-btn {
      background: #ffcc29;
      border: 1px solid #ffcc29;
      color: #373435;
      padding: 5px;
      cursor: pointer
    }

    /* Loader Style */
    .loader-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.8);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    }
    
    .loader {
      border: 4px solid #f3f3f3;
      border-top: 4px solid #373435;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      animation: spin 1s linear infinite;
    }
    
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    
    .loader-overlay p {
      margin-top: 10px;
      font-size: 1rem;
      color: #333;
    }
    
  
    @media (max-width: 768px) {
      .date-filter-form-campaign {
        flex-direction: column;
        align-items: flex-start;
    }
  
    .campaign-date-field {
        width: 100%;
        align-items: center;
    }
  
    .campaign-form-actions {
        flex-direction: column;
        width: 100%;
    }
  
    .campaign-form-actions .btn {
        width: 100%;
    }
  
    .campaign-report-table-container {
      overflow-x: auto;
    }
    }

    /* Modal Page for analytics report*/
  .preview-modal-campaign-analytics {
    position: fixed;
    top: 50px;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .preview-inside-content-analytics {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 450px;
    max-width: 90%; 
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    transform: translateY(-50px);
    transition: transform 0.3s ease;
    word-wrap: break-word; 
    overflow-wrap: break-word; 
  }

  .preview-inside-content-analytics h3 {
    color: #373435
  }
  
  .analytics-container {
      display: flex;
      flex-direction: column;
      gap: 15px;
      margin-top: 15px;
  }
  
  .analytics-card {
      background: linear-gradient(50deg, #ffcc29, #FFD95F);
      border-radius: 10px;
      padding: 15px;
      display: flex;
      align-items: center;
      gap: 10px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      transition: transform 0.2s ease-in-out;
  }
  
  .analytics-card:hover {
      transform: translateY(-3px);
  }

  .analytics-card .card-text {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    font-size: 16px;
    font-weight: 600;
  }
  
  .card-icon {
      font-size: 20px;
      color: black;
  }
  
  .card-text {
      display: flex;
      flex-direction: column;
      font-size: 16px;
      font-weight: 600;
  }
  
  .card-text strong {
      font-size: 20px;
  }

  .modal-buttons-wrap {
    display: flex;
    justify-content: space-between;
  }

  
  .modal-buttons-wrap .back-btn {
      margin-top: 20px;
      padding: 10px 20px;
      background: #373435;
      color: #ffcc29;
      border-radius: 5px;
      cursor: pointer;
      font-weight: bold;
  }

  .modal-buttons-wrap .cancel-btn {
      margin-top: 20px;
      padding: 10px 20px;
      background-color: #fb3d4e;
      color: #fff;
      border: 1px solid #fb3d4e;
      border-radius: 5px;
      cursor: pointer;
      font-weight: bold;
  }

  /* MODAL PAGE for Cliecker Report */
  .preview-modal-campaign-clicker {
    position: fixed;
    top: 50px;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .preview-inside-content-clicker {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 1000px;
    max-width: 90%; 
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    transform: translateY(-50px);
    transition: transform 0.3s ease;
    word-wrap: break-word; 
    overflow-wrap: break-word; 
  }

  .preview-inside-content-clicker h3 {
    color: #373435
  }

  .clicker-data-table {
    color: #373435;
  }

  .cancel-btn-clicker {
    margin-top: 20px;
    padding: 10px 20px;
    background-color: #fb3d4e;
    color: #fff;
    border: 1px solid #fb3d4e;
    border-radius: 5px;
    cursor: pointer;
    font-weight: bold;
}


/* Pagination style */
.pagination-footer {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

@media (max-width: 900px) {
  .pagination-footer {
    flex-direction: column;
    align-items: center;
  }
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.pagination button {
  margin: 5px;
  padding: 5px 10px;
  border: 1px solid #ddd;
  background-color: white;
  cursor: pointer;
}

.pagination button.active {
  background-color: #ffcc29;
  color: #373435;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/CampaignReport/CampaignReport.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB;EACF;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,yBAAyB;EAC3B;;IAEE;MACE,aAAa;MACb,SAAS;MACT,mBAAmB;MACnB,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;MACjB,eAAe;MACf,WAAW;MACX,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,yBAAyB;MACzB,qBAAqB;IACvB;;IAEA;MACE,yBAAyB;MACzB,qBAAqB;MACrB,qFAAqF;IACvF;;IAEA;MACE,mBAAmB;MACnB,cAAc;IAChB;;IAEA;MACE,mBAAmB;MACnB,cAAc;MACd,qFAAqF;IACvF;;EAEF,sBAAsB;AACxB;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;IAEI,+BAA+B;IAC/B;MACE,WAAW;MACX,gBAAgB;MAChB,gBAAgB;MAChB,kBAAkB;MAClB,yCAAyC;MACzC,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,yBAAyB;MACzB,gBAAgB;IAClB;;IAEA;;MAEE,kBAAkB;MAClB,sBAAsB;MACtB,eAAe;IACjB;;IAEA;MACE,yBAAyB;MACzB,cAAc;MACd,gBAAgB;MAChB,yBAAyB;MACzB,gBAAgB;IAClB;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,0CAA0C;IAC5C;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,gCAAgC;IAClC;;IAEA,kBAAkB;IAClB;MACE,mBAAmB;MACnB,cAAc;MACd,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,mBAAmB;MACnB,cAAc;IAChB;;IAEA,iBAAiB;IACjB;MACE,yBAAyB;IAC3B;;IAEA;MACE,aAAa;IACf;;IAEA;MACE;QACE,aAAa;MACf;IACF;;IAEA;MACE;QACE,aAAa;MACf;IACF;;IAEA;MACE,mBAAmB;MACnB,yBAAyB;MACzB,cAAc;MACd,YAAY;MACZ,cAAc;MACd;IACF;;IAEA;MACE,mBAAmB;MACnB,yBAAyB;MACzB,cAAc;MACd,YAAY;MACZ;IACF;;IAEA,iBAAiB;IACjB;MACE,eAAe;MACf,MAAM;MACN,OAAO;MACP,QAAQ;MACR,SAAS;MACT,0CAA0C;MAC1C,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,aAAa;IACf;;IAEA;MACE,yBAAyB;MACzB,6BAA6B;MAC7B,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,kCAAkC;IACpC;;IAEA;MACE,KAAK,uBAAuB,EAAE;MAC9B,OAAO,yBAAyB,EAAE;IACpC;;IAEA;MACE,gBAAgB;MAChB,eAAe;MACf,WAAW;IACb;;;IAGA;MACE;QACE,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;MACE,gBAAgB;IAClB;IACA;;IAEA,mCAAmC;EACrC;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,yCAAyC;IACzC,4BAA4B;IAC5B,+BAA+B;IAC/B,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE;EACF;;EAEA;MACI,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,gBAAgB;EACpB;;EAEA;MACI,oDAAoD;MACpD,mBAAmB;MACnB,aAAa;MACb,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,wCAAwC;MACxC,sCAAsC;EAC1C;;EAEA;MACI,2BAA2B;EAC/B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;MACI,eAAe;MACf,YAAY;EAChB;;EAEA;MACI,aAAa;MACb,sBAAsB;MACtB,eAAe;MACf,gBAAgB;EACpB;;EAEA;MACI,eAAe;EACnB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;;EAGA;MACI,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;MACnB,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,iBAAiB;EACrB;;EAEA;MACI,gBAAgB;MAChB,kBAAkB;MAClB,yBAAyB;MACzB,WAAW;MACX,yBAAyB;MACzB,kBAAkB;MAClB,eAAe;MACf,iBAAiB;EACrB;;EAEA,mCAAmC;EACnC;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,yCAAyC;IACzC,4BAA4B;IAC5B,+BAA+B;IAC/B,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE;EACF;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;;AAGA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["\r\n.date-filter-form-campaign {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 25px 20px;\r\n  margin: 20px auto; \r\n  gap: 20px;\r\n  background-color: #fff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px; \r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  }\r\n    \r\n  .campaign-date-field {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 25%\r\n  }\r\n    \r\n  .campaign-date-field label {\r\n    font-weight: bold;\r\n    margin-bottom: 8px;\r\n    text-align: left;\r\n  }\r\n    \r\n  .campaign-date-field input {\r\n    padding: 10px 5px;\r\n    font-size: 16px;\r\n    border: 1px solid #f2f2f2;\r\n  }\r\n    \r\n    .campaign-form-actions {\r\n      display: flex;\r\n      gap: 10px;\r\n      align-items: center;\r\n      padding: 15px 0 0;\r\n    }\r\n    \r\n    .campaign-form-actions .btn {\r\n      padding: 8px 16px;\r\n      font-size: 16px;\r\n      color: #fff;\r\n      border-radius: 4px;\r\n      cursor: pointer;\r\n    }\r\n    \r\n    .campaign-form-actions .submit-btn {\r\n      background-color: #44a67e;\r\n      border-color: #44a67e;\r\n    }\r\n    \r\n    .campaign-form-actions .submit-btn:hover {\r\n      background-color: #44a67e;\r\n      border-color: #44a67e;\r\n      box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n    }\r\n    \r\n    .campaign-form-actions .download-btn {\r\n      background: #373435;\r\n      color: #ffcc29;\r\n    }\r\n    \r\n    .campaign-form-actions .download-btn:hover {\r\n      background: #373435;\r\n      color: #ffcc29;\r\n      box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n    }\r\n\r\n  /* Responsive Styles */\r\n@media (max-width: 700px) {\r\n  .date-filter-form-campaign {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 15px;\r\n  }\r\n\r\n  .campaign-date-field input {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .campaign-form-actions {\r\n    flex-direction: column;\r\n    width: 100%;\r\n  }\r\n\r\n  .campaign-form-actions .btn {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n}  \r\n  \r\n    /* Summary Report Table Style */\r\n    .campaign-report-table-container {\r\n      width: 100%;\r\n      overflow-x: auto;\r\n      margin-top: 20px;\r\n      border-radius: 8px;\r\n      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n      background: #fff;\r\n    }\r\n    \r\n    .campaign-report-table {\r\n      width: 100%;\r\n      border-collapse: collapse;\r\n      text-align: left;\r\n    }\r\n    \r\n    .campaign-report-table th,\r\n    .campaign-report-table td {\r\n      padding: 12px 15px;\r\n      border: 1px solid #ddd;\r\n      font-size: 14px;\r\n    }\r\n    \r\n    .campaign-report-table th {\r\n      background-color: #f4f4f4;\r\n      color: #373435;\r\n      font-weight: 600;\r\n      text-transform: uppercase;\r\n      text-align: left;\r\n    }\r\n    \r\n    .campaign-report-table tbody tr:nth-child(even) {\r\n      background-color: #f9f9f9;\r\n    }\r\n    \r\n    .campaign-report-table tbody tr:hover {\r\n      background-color:  rgba(255, 204, 41, 0.2);\r\n    }\r\n    \r\n    .campaign-report-table td {\r\n      color: #373435;\r\n    }\r\n    \r\n    .campaign-report-table tbody tr:last-child td {\r\n      border-bottom: 2px solid #ffcc29;\r\n    }\r\n  \r\n    /* Expand Button */\r\n    .campaign-expand-btn {\r\n      background: #373435;\r\n      color: #ffcc29;\r\n      border: none;\r\n      padding: 5px 10px;\r\n      cursor: pointer;\r\n      border-radius: 4px;\r\n      font-size: 16px;\r\n    }\r\n    \r\n    .campaign-expand-btn:hover {\r\n      background: #ffcc29;\r\n      color: #373435;\r\n    }\r\n    \r\n    /* Expanded Row */\r\n    .campaign-expanded-row {\r\n      background-color: #eef7ff;\r\n    }\r\n    \r\n    .campaign-expanded-content {\r\n      padding: 10px;\r\n    }\r\n\r\n    @media screen and (max-width: 1100px) {\r\n      .campaign-under-1000px {\r\n        display: none;\r\n      }\r\n    }\r\n    \r\n    @media screen and (min-width: 1101px) {\r\n      .campaign-toggle-button-expansion {\r\n        display: none;\r\n      }\r\n    }\r\n\r\n    .analytics-btn {\r\n      background: #373435;\r\n      border: 1px solid #373435;\r\n      color: #ffcc29;\r\n      padding: 5px;\r\n      margin: 0 10px;\r\n      cursor: pointer\r\n    }\r\n\r\n    .clicker-btn {\r\n      background: #ffcc29;\r\n      border: 1px solid #ffcc29;\r\n      color: #373435;\r\n      padding: 5px;\r\n      cursor: pointer\r\n    }\r\n\r\n    /* Loader Style */\r\n    .loader-overlay {\r\n      position: fixed;\r\n      top: 0;\r\n      left: 0;\r\n      right: 0;\r\n      bottom: 0;\r\n      background-color: rgba(255, 255, 255, 0.8);\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      z-index: 9999;\r\n    }\r\n    \r\n    .loader {\r\n      border: 4px solid #f3f3f3;\r\n      border-top: 4px solid #373435;\r\n      border-radius: 50%;\r\n      width: 40px;\r\n      height: 40px;\r\n      animation: spin 1s linear infinite;\r\n    }\r\n    \r\n    @keyframes spin {\r\n      0% { transform: rotate(0deg); }\r\n      100% { transform: rotate(360deg); }\r\n    }\r\n    \r\n    .loader-overlay p {\r\n      margin-top: 10px;\r\n      font-size: 1rem;\r\n      color: #333;\r\n    }\r\n    \r\n  \r\n    @media (max-width: 768px) {\r\n      .date-filter-form-campaign {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n    }\r\n  \r\n    .campaign-date-field {\r\n        width: 100%;\r\n        align-items: center;\r\n    }\r\n  \r\n    .campaign-form-actions {\r\n        flex-direction: column;\r\n        width: 100%;\r\n    }\r\n  \r\n    .campaign-form-actions .btn {\r\n        width: 100%;\r\n    }\r\n  \r\n    .campaign-report-table-container {\r\n      overflow-x: auto;\r\n    }\r\n    }\r\n\r\n    /* Modal Page for analytics report*/\r\n  .preview-modal-campaign-analytics {\r\n    position: fixed;\r\n    top: 50px;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .preview-inside-content-analytics {\r\n    background: white;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    width: 450px;\r\n    max-width: 90%; \r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\r\n    transform: translateY(-50px);\r\n    transition: transform 0.3s ease;\r\n    word-wrap: break-word; \r\n    overflow-wrap: break-word; \r\n  }\r\n\r\n  .preview-inside-content-analytics h3 {\r\n    color: #373435\r\n  }\r\n  \r\n  .analytics-container {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 15px;\r\n      margin-top: 15px;\r\n  }\r\n  \r\n  .analytics-card {\r\n      background: linear-gradient(50deg, #ffcc29, #FFD95F);\r\n      border-radius: 10px;\r\n      padding: 15px;\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 10px;\r\n      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n      transition: transform 0.2s ease-in-out;\r\n  }\r\n  \r\n  .analytics-card:hover {\r\n      transform: translateY(-3px);\r\n  }\r\n\r\n  .analytics-card .card-text {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .card-icon {\r\n      font-size: 20px;\r\n      color: black;\r\n  }\r\n  \r\n  .card-text {\r\n      display: flex;\r\n      flex-direction: column;\r\n      font-size: 16px;\r\n      font-weight: 600;\r\n  }\r\n  \r\n  .card-text strong {\r\n      font-size: 20px;\r\n  }\r\n\r\n  .modal-buttons-wrap {\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  \r\n  .modal-buttons-wrap .back-btn {\r\n      margin-top: 20px;\r\n      padding: 10px 20px;\r\n      background: #373435;\r\n      color: #ffcc29;\r\n      border-radius: 5px;\r\n      cursor: pointer;\r\n      font-weight: bold;\r\n  }\r\n\r\n  .modal-buttons-wrap .cancel-btn {\r\n      margin-top: 20px;\r\n      padding: 10px 20px;\r\n      background-color: #fb3d4e;\r\n      color: #fff;\r\n      border: 1px solid #fb3d4e;\r\n      border-radius: 5px;\r\n      cursor: pointer;\r\n      font-weight: bold;\r\n  }\r\n\r\n  /* MODAL PAGE for Cliecker Report */\r\n  .preview-modal-campaign-clicker {\r\n    position: fixed;\r\n    top: 50px;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n  }\r\n\r\n  .preview-inside-content-clicker {\r\n    background: white;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    width: 1000px;\r\n    max-width: 90%; \r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\r\n    transform: translateY(-50px);\r\n    transition: transform 0.3s ease;\r\n    word-wrap: break-word; \r\n    overflow-wrap: break-word; \r\n  }\r\n\r\n  .preview-inside-content-clicker h3 {\r\n    color: #373435\r\n  }\r\n\r\n  .clicker-data-table {\r\n    color: #373435;\r\n  }\r\n\r\n  .cancel-btn-clicker {\r\n    margin-top: 20px;\r\n    padding: 10px 20px;\r\n    background-color: #fb3d4e;\r\n    color: #fff;\r\n    border: 1px solid #fb3d4e;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    font-weight: bold;\r\n}\r\n\r\n\r\n/* Pagination style */\r\n.pagination-footer {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .pagination-footer {\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n}\r\n\r\n.pagination {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 10px;\r\n}\r\n\r\n.pagination button {\r\n  margin: 5px;\r\n  padding: 5px 10px;\r\n  border: 1px solid #ddd;\r\n  background-color: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.pagination button.active {\r\n  background-color: #ffcc29;\r\n  color: #373435;\r\n}\r\n\r\n.pagination button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
